(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wa-pdp-dialogs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wa-pdp-dialogs')) {
  customElements.define('wa-pdp-dialogs', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.trigger = null;
      document.addEventListener('click', event => {
        const button = event.target.closest('[data-wa-open]');
        if (!button) return;
        const dialog = document.getElementById(button.dataset.waOpen);
        if (!dialog || !this.contains(dialog)) return;
        const current = this.querySelector('dialog[open]');
        if (current === dialog) return;
        if (current) { this.switching = true; current.close(); }
        if (!this.contains(button)) this.trigger = button;
        dialog.classList.remove('wa-entered', 'wa-closing');
        dialog.showModal();
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (dialog.open && !dialog.classList.contains('wa-closing')) dialog.classList.add('wa-entered');
        }));
        this.switching = false;
        document.documentElement.classList.add('wa-dialog-open');
      }, {signal: this.controller.signal});
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('click', event => {
          if (event.target.closest('[data-wa-close]')) this.closePanel(dialog);
          if (event.target === dialog) {
            const r = dialog.getBoundingClientRect();
            if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.closePanel(dialog);
          }
        });
        dialog.addEventListener('cancel', event => {
          event.preventDefault();
          this.closePanel(dialog);
        }, {signal: this.controller.signal});
        dialog.addEventListener('close', () => {
          clearTimeout(dialog.waCloseTimer);
          dialog.classList.remove('wa-entered', 'wa-closing');
          if (!this.querySelector('dialog[open]')) {
            document.documentElement.classList.remove('wa-dialog-open');
            if (!this.switching && this.trigger?.isConnected) this.trigger.focus({preventScroll:true});
          }
        });
      });
      if (window.FoxThemeEvents && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
          if (data.sectionId !== this.dataset.sectionId) return;
          const root = document.getElementById('MainProduct-' + this.dataset.sectionId);
          const destination = root?.querySelector('.legal-line');
          const source = data.html?.querySelector('.legal-line');
          if (destination && source) destination.innerHTML = source.innerHTML;
          const credits = this.querySelector('[data-wa-credits]');
          const nextCredits = data.html?.querySelector('[data-wa-credits]');
          if (credits && nextCredits) credits.innerHTML = nextCredits.innerHTML;
          const sku = this.querySelector('[data-wa-sku]');
          const nextSku = data.html?.querySelector('[data-wa-sku]');
          if (sku && nextSku) { sku.innerHTML = nextSku.innerHTML; sku.hidden = nextSku.hidden; }
        });
      }
    }
    closePanel(dialog) {
      if (!dialog.open || dialog.classList.contains('wa-closing')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { dialog.close(); return; }
      dialog.classList.add('wa-closing');
      dialog.classList.remove('wa-entered');
      const finish = () => {
        clearTimeout(dialog.waCloseTimer);
        dialog.removeEventListener('transitionend', onEnd);
        if (dialog.open && dialog.classList.contains('wa-closing')) dialog.close();
      };
      const onEnd = event => { if (event.target === dialog && event.propertyName === 'transform') finish(); };
      dialog.addEventListener('transitionend', onEnd, {signal: this.controller.signal});
      dialog.waCloseTimer = setTimeout(finish, 600);
    }
    disconnectedCallback() { this.querySelectorAll('dialog').forEach(dialog => clearTimeout(dialog.waCloseTimer)); this.controller?.abort(); this.unsubscribe?.(); document.documentElement.classList.remove('wa-dialog-open'); }
  });
}
if (!customElements.get('wa-shipping')) {
  customElements.define('wa-shipping', class extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;this.ready=true;
      const select=this.closest('dialog').querySelector('select[name="country_code"]');
      const source=this.querySelector('.wa-shipping-source .rte');
      const headings=Array.from(source.querySelectorAll('h4'));
      const cards=Array.from(source.querySelectorAll('[data-wa-shipping-codes]'));
      const eu='AT BE BG HR CY CZ DK EE FI FR GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE'.split(' ');
      const groups=[{codes:['DE'],match:/^(Deutschland|Germany)$/i},{codes:eu,match:/^(Europäische Union|European Union)$/i},{codes:'IS LI NO CH RS UA GB IL'.split(' '),match:/Schweiz|Switzerland/i},{codes:['US'],match:/^(USA|United States)$/i},{codes:'AM CN HK IN JP CA KG MY PH SG KR TW VN'.split(' '),match:/Japan/i},{codes:['KZ'],match:/Kasachstan|Kazakhstan/i},{codes:'AU AR BR CL NZ ZA'.split(' '),match:/Australien|Australia/i}];
      const target=this.querySelector('.wa-shipping-selected');
      const update=()=>{
        const iso=select?.value || this.dataset.country;
        target.replaceChildren();
        this.querySelector('[data-wa-import]').hidden=iso==='DE'||eu.includes(iso);
        const group=groups.find(g=>g.codes.includes(iso));
        const card=cards.find(c=>c.dataset.waShippingCodes.split(' ').includes(iso));
        if(card){
          this.querySelector('[data-wa-shipping-unknown]').hidden=true;
          const content=card.querySelector('.wa-rate-content');
          Array.from(content.children).forEach(n=>target.append(n.cloneNode(true)));
          return;
        }
        const heading=group && headings.find(h=>group.match.test(h.textContent.trim()));
        this.querySelector('[data-wa-shipping-unknown]').hidden=!!heading;
        if(!heading)return;
        let n=heading.nextElementSibling;
        while(n && n.tagName!=='H4' && n.tagName!=='HR'){if(n.textContent.replace(/\u00a0/g,' ').trim() || n.querySelector('table'))target.append(n.cloneNode(true));n=n.nextElementSibling;}
      };
      this.controller=new AbortController();select?.addEventListener('change',update,{signal:this.controller.signal});update();
    }
    disconnectedCallback(){this.controller?.abort();this.ready=false;}
  });
}
if (!customElements.get('wa-tasting')) {
  customElements.define('wa-tasting',class extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      const stages=[{pattern:/^(Aroma|Nase|Nose|Aromas?)\s*:/i,label:this.dataset.nose},{pattern:/^(Geschmack|Gaumen|Taste|Palate)\s*:/i,label:this.dataset.palate},{pattern:/^(Nachklang|Abgang|Finish)\s*:/i,label:this.dataset.finish}];
      Array.from(this.querySelectorAll('p')).forEach(p=>{
        const text=p.textContent.trim();const index=stages.findIndex(s=>s.pattern.test(text));if(index<0)return;
        const stage=stages[index],card=document.createElement('section'),head=document.createElement('header'),number=document.createElement('span'),title=document.createElement('h3'),body=document.createElement('p');
        card.className='wa-taste-stage';number.textContent='0'+(index+1);number.setAttribute('aria-hidden','true');title.textContent=stage.label;body.textContent=text.replace(stage.pattern,'').trim();head.append(title);card.append(head,body);
        p.replaceWith(card);
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
